import { placementParam } from "./rootPlacementSearch";

export type TaskListDateScope = "hepsi" | "tarihli" | "tarihsiz";
export const TASK_PRESETS = ["acik", "bugun", "gecikmis", "tamamlanan", "durdurulan"] as const;
export const TASK_ORDERS = ["smart", "scheduled", "created", "updated", "title", "manual"] as const;
export type TaskPreset = (typeof TASK_PRESETS)[number];
export type TaskListOrder = (typeof TASK_ORDERS)[number];

export type TaskListSearch = {
  tarih?: Exclude<TaskListDateScope, "hepsi">;
  ctx?: string;
  baglilari_goster?: 0 | 1;
  preset?: TaskPreset;
  order?: TaskListOrder;
};

export function validateTaskListSearch(search: Record<string, unknown>): TaskListSearch {
  return {
    ctx: typeof search.ctx === "string" ? search.ctx : undefined,
    tarih: search.tarih === "tarihli" || search.tarih === "tarihsiz" ? search.tarih : undefined,
    baglilari_goster: placementParam(search.baglilari_goster),
    preset: TASK_PRESETS.includes(search.preset as TaskPreset)
      ? (search.preset as TaskPreset)
      : undefined,
    order: TASK_ORDERS.includes(search.order as TaskListOrder)
      ? (search.order as TaskListOrder)
      : undefined,
  };
}
